// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"84":"d179b9a7","607":"c20eea69","865":"5d23003e"}[chunkId] + ".css";
};